import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import Button from '../../../common/button/Button';
// import renderHTMLContent from '../../../helpers/transformHTML';
import NewsImage from './NewsImage';
import EmbededPodcast from '../../../common/EmbededPodcast/EmbededPodcast';
import Sharing from '../../../common/sharing/Sharing';
import VideoPlayer from '../../../common/VideoPlayer/VideoPlayerComponent';
import Youtube from '../../../common/Youtube/Youtube';
import TruncatedContent from '../../../utils/TruncatedContent';
import formatDateToBR from '../../../utils/formatDateToBR';
import CalculateTimeSeconds from '../../../utils/calculateTimeSeconds';
import { newsText } from '../helpers/newsSeo';

const NewsItemComponent = ({
    data,
    isFeatured,
    isVisible,
    countNewsView,
    location,
    // maxLengthText = 53,
    showContent = false,
    selectedCategory,
    breakpoint,
}) => {
    const [coverVideoYoutubeId, setCoverVideoYoutubeId] = useState(data.coverVideoYoutubeId || null);
    const [isMounted, setIsMounted] = useState(false);

    // Handle visibility to count news views
    useEffect(() => {
        if (isMounted && isVisible) {
            countNewsView({
                newsId: data.id,
                timestamp: Date.now(),
            });
        }
    }, [isMounted, isVisible, data.id, countNewsView]);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    // Handle route change to reset the YouTube video
    useEffect(() => {
        const handleRouteChange = () => {
            setCoverVideoYoutubeId(false); // Remove iframe

            setTimeout(() => {
                setCoverVideoYoutubeId(data.coverVideoYoutubeId); // Reload iframe
            }, 0);
        };

        handleRouteChange(); // Trigger initially
    }, [location.pathname, data.coverVideoYoutubeId]);

    // const innerHTMLContentNews = useCallback(
    //     (content) => (isMounted ? renderHTMLContent(content, 50) : null),
    //     [isMounted, maxLengthText],
    // );

    const {
        date,
        content,
        oldImage,
        slug,
        titleHome,
        title,
        podcastId,
        podcastType,
        podcastPlayerStyle,
        podcastPlayerColor,
        coverVideoFileName,
    } = data;

    const shareTitle = `Ouvi falar na Antena1.com.br: ${title} - `;
    const link = `/noticias/${slug}`;

    const responsiveBreakpoints = isMounted ? breakpoint : breakpoint.serverBreakPoints;
    const isResponsive = (name) => responsiveBreakpoints && responsiveBreakpoints[name];

    const withVideoHeight = isFeatured
        ? (isResponsive('isExtraLarge') || isResponsive('isLarge') || isResponsive('isMedium') ? 837 : 430)
        : (isResponsive('isSmall') || isResponsive('isExtraSmall') ? 430 : 462);
    const videoQuality = (isFeatured && !isResponsive('isSmall') && !isResponsive('isExtraSmall')) ? '720p' : '480p';

    const formatCategoryName = (category) => {
        if (!category) return '';

        const map = {
            politica: 'Política',
            saude: 'Saúde',
            economia: 'Economia',
            musica: 'Música',
        };

        return map[category.toLowerCase()] || category.charAt(0).toUpperCase() + category.slice(1);
    };

    return (
        <div>
            <div className={`${isFeatured ? ' featured tw-pt-4' : 'tw-pt-4'}`}>
                {/* {data.newNews && <div className="newTag">Novo</div>} */}
                {coverVideoFileName || coverVideoYoutubeId ? (
                    <div style={{ height: withVideoHeight }}>
                        {coverVideoYoutubeId ? (
                            <div className="youtubeContainer">
                                <Youtube videoId={coverVideoYoutubeId} />
                            </div>
                        ) : (
                            <VideoPlayer
                                where="newsBlocks"
                                videoQuality={videoQuality}
                                fileName={coverVideoFileName}
                            />
                        )}
                        <Button className="btnToNews withVideo" title={`Clique e saiba mais sobre: ${title}`} to={link} route={slug}>
                            <article>
                                {podcastType && (
                                    <EmbededPodcast
                                        showLoadButton
                                        podcastId={podcastId}
                                        podcastType={podcastType}
                                        playerStyle={podcastPlayerStyle}
                                        playerColor={podcastPlayerColor}
                                        playerType="mini"
                                        episodeLink={link}
                                    />
                                )}
                                <header>
                                    <h3>
                                        {titleHome || title}
                                    </h3>
                                </header>
                                <div className="containerContent">
                                    <div>
                                        <TruncatedContent
                                            content={content}
                                            maxLength={95}
                                        />
                                    </div>
                                    <div className="shadow" />
                                </div>
                            </article>
                        </Button>
                    </div>
                ) : (
                    <Button
                        className="tw-w-full hover:tw-no-underline"
                        title={`Clique e saiba mais sobre: ${title}`}
                        to={link}
                        route={slug}
                    >
                        <article className="">
                            <div className="tw-flex tw-justify-between tw-text-gray-500 alternativeFontSize tw-mb-2 data-publicacao">
                                <span className="tw-capitalize">
                                    {selectedCategory
                                        ? `${formatCategoryName(selectedCategory)} – ${formatDateToBR(data.date)}`
                                        : formatDateToBR(data.date)}
                                </span>
                                <span className="tw-flex tw-items-center tw-gap-2 tw-justify-around">
                                    <div>
                                        <FontAwesomeIcon icon={faClock} className="faNewsItem" width="16" />
                                    </div>
                                    <div>
                                        <CalculateTimeSeconds dateToFormat={date} />
                                    </div>
                                </span>
                            </div>

                            <header className="tw-m-0 tw-p-0">
                                <div className="title-news">
                                    <h3 className="tw-text-lg tw-text-start tw-font-bold tw-text-black tw-mb-0 limitText2">
                                        {titleHome || title}
                                    </h3>
                                </div>
                            </header>

                            <div
                                className={`tw-relative  ${oldImage ? 'tw-border tw-border-gray-300' : ''
                                }`}
                                style={podcastType ? { border: `1px solid ${podcastPlayerColor}` } : {}}
                            >
                                <figure className="tw-overflow-hidden">
                                    <NewsImage
                                        news={data}
                                        sizes="(min-width: 1280px) 380px, (min-width: 1024px) 30vw, (min-width: 768px) 45vw, calc(100vw - 80px)"
                                    />
                                </figure>
                            </div>

                            {podcastType && (
                                <EmbededPodcast
                                    showLoadButton
                                    podcastId={podcastId}
                                    podcastType={podcastType}
                                    playerStyle={podcastPlayerStyle}
                                    playerColor={podcastPlayerColor}
                                    playerType="mini"
                                    episodeLink={link}
                                />
                            )}
                            {showContent && (
                                <div className="tw-mt-4">
                                    <div className="tw-text-black-600 tw-text-start">
                                        <p className="limitText2">
                                            {newsText(content)}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </article>
                    </Button>

                )}
                <div className="tw-flex tw-justify-start tw-gap-4 tw-mt-4">
                    <Sharing
                        path={link}
                        shareButtonsTo={['facebook', 'twitter', 'whatsapp', 'linkedin']}
                        iconSize={28}
                        widthBlockIcon={26}
                        facebook={{ quote: shareTitle, hashtag: '#Antena1' }}
                        whatsapp={{ title: shareTitle }}
                        twitter={{ title: shareTitle, hashtags: ['Noticias', 'Antena1'] }}
                        linkedin={{ title: shareTitle }}
                    />

                </div>
            </div>
        </div>
    );
};

NewsItemComponent.propTypes = exact({
    data: PropTypes.object.isRequired,
    isFeatured: PropTypes.bool,
    isVisible: PropTypes.bool,
    showContent: PropTypes.bool,
    countNewsView: PropTypes.func,
    selectedCategory: PropTypes.string,
    // maxLengthText: PropTypes.number,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    breakpoint: PropTypes.object,
    /* eslint-disable react/no-unused-prop-types */
    staticContext: PropTypes.object, // Injected through withRouters but not used
    history: PropTypes.object, // Injected through withRouters but not used
    match: PropTypes.object, // Injected through withRouters but not used
    /* eslint-enable react/no-unused-prop-types */
});

export default NewsItemComponent;
